import { render, staticRenderFns } from "./Turnstile.vue?vue&type=template&id=f7d0b534&scoped=true"
import script from "./Turnstile.vue?vue&type=script&lang=js"
export * from "./Turnstile.vue?vue&type=script&lang=js"
import style0 from "./Turnstile.vue?vue&type=style&index=0&id=f7d0b534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d0b534",
  null
  
)

export default component.exports